import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import SocialLogin from "./SocialLogin";
import LoginWithEmail from "./LoginWithEmail";
import LoginWithPhone from "./LoginWithPhone";
import { useDispatch } from "react-redux";
import { setModal } from "../../../features/modal/ModalSlice";
import getDemoUser from "../../../utils/demo";
import { setUserDetails } from "../../../features/user/UserSlice";

const Login = () => {
  const [loginVia, setLoginVia] = useState("EMAIL");

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const toggleLoginVia = () => {
    if (loginVia === "EMAIL") setLoginVia("PHONE");
    else setLoginVia("EMAIL");
  };

  const handleSignupPopUp = () => {
    dispatch(setModal({ type: "SIGNUP" }));
  };

  const handleDemo = async () => {
    const response = await getDemoUser();
    dispatch(
      setUserDetails({
        id: response?.user?.id,
        company_id: response?.user?.company_id,
        name: response?.user?.name,
        email: response?.user?.email_id,
        phone_number: response?.user?.phone_number,
        image: response?.user?.image,
        role: response?.user?.user_type,
        company_domain: response?.user?.company_details?.domain,
      })
    );

    navigate("/demo");
  };

  return (
    <div>
      <h2>Login</h2>

      {loginVia === "EMAIL" ? <LoginWithEmail /> : <LoginWithPhone />}

      <div className="d-flex justify-content-center">
        <hr className="w-50 mx-2" />
        <p>or</p>
        <hr className="w-50 mx-2" />
      </div>

      <SocialLogin />

      <div className="d-flex justify-content-center">
        <hr className="w-50 mx-2" />
        <p>or</p>
        <hr className="w-50 mx-2" />
      </div>
      <button className="btn btn-primary custom-btn-full my-3" onClick={() => toggleLoginVia()}>
        <div></div>
        Sign in With {loginVia === "EMAIL" ? "Phone" : "Email"}
        <div></div>
      </button>

      <div className="text-center text-muted small">
        Create an account <Link onClick={handleSignupPopUp}>Register</Link>
      </div>
      <div className="text-center text-muted small">
        <Link onClick={handleDemo}>Try Now</Link>
      </div>
    </div>
  );
};

export default Login;
